import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.google-hangouts-bot', {
        url: '/google-hangouts-bot',
        component: 'companyGoogleHangoutsBot',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/google-hangouts-bot/google-hangouts-bot.state.js